import { device } from "@src/theme";
import styled from "styled-components";

export const TotalLabelWrapper = styled.div``;

export const TotalLabel = styled.span<{ grayText?: boolean }>`
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme, grayText }): string =>
    grayText ? theme.colors.gray : theme.colors.yellow};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-align: flex-end;
  @media ${device.mobile} {
    font-size: 1rem;
  }

  @media ${device.tablet} {
    font-size: 18px;
  }

  @media ${device.laptop} {
    font-size: 20px;
  }
`;
